<app-sidenav #sidenav></app-sidenav>

<cui-navbar>
  <button mat-icon-button (click)="sidenav.open()" class="open-sidenav">
    <mat-icon svgIcon="nav/menu"></mat-icon>
  </button>
  <h1>Søg plukliste</h1>
</cui-navbar>

<div class="content" *ngIf="options | async as opts; else loading">
  <form [formGroup]="searchForm" novalidate>
    <div class="inputs">
      <mat-form-field>
        <mat-select cui class="branch" placeholder="Filial" formControlName="branch">
          <mat-option [value]="branch.id" *ngFor="let branch of opts.branches">{{branch.shortName}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select cui class="department" multiple placeholder="Afdeling" formControlName="department">
          <cui-select-all [controlForm]="searchForm.controls.department" [options]="opts.placements.departments" property="id" selectLabel="Vælg alle"
                          deselectLabel="Fravælg alle"></cui-select-all>
          <mat-option [value]="department.id" *ngFor="let department of opts.placements.departments">{{department.shortName}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select cui class="location" multiple placeholder="Opstilling" formControlName="location">
          <cui-select-all [controlForm]="searchForm.controls.location" [options]="opts.placements.locations" property="id" selectLabel="Vælg alle"
                          deselectLabel="Fravælg alle"></cui-select-all>
          <mat-option [value]="location.id" *ngFor="let location of opts.placements.locations">{{location.shortName}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select cui class="sublocation" multiple placeholder="Delopstilling" formControlName="sublocation">
          <cui-select-all [controlForm]="searchForm.controls.sublocation" [options]="opts.placements.sublocations" property="id" selectLabel="Vælg alle"
                          deselectLabel="Fravælg alle"></cui-select-all>
          <mat-option [value]="sublocation.id" *ngFor="let sublocation of opts.placements.sublocations">{{sublocation.shortName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select cui class="material-group" multiple placeholder="Materialegruppe" formControlName="materialGroup">
          <cui-select-all [controlForm]="searchForm.controls.materialGroup" [options]="opts.materialGroups" property="id" selectLabel="Vælg alle"
                          deselectLabel="Fravælg alle"></cui-select-all>
          <mat-option [value]="materialGroup.id" *ngFor="let materialGroup of opts.materialGroups">{{materialGroup.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select cui class="pickup-branch" multiple placeholder="Afhentningsfilial" formControlName="pickupBranch">
          <cui-select-all [controlForm]="searchForm.controls.pickupBranch" [options]="opts.pickupBranches" property="id" selectLabel="Vælg alle"
                          deselectLabel="Fravælg alle"></cui-select-all>
          <mat-option [value]="pickupBranch.id" *ngFor="let pickupBranch of opts.pickupBranches">{{pickupBranch.shortName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>

  <div class="button-container">
    <button class="submit"
            cui
            mat-button
            color="primary"
            [disabled]="searchForm.invalid"
            routerLink="../results"
            queryParamsHandling="preserve">
      Søg
    </button>
  </div>

  <div class="button-container">
    <button class="reset" cui mat-button (click)="reset()">Nulstil</button>
  </div>
</div>

<ng-template #loading>
  <div class="loading">
    <mat-icon svgIcon="loading"></mat-icon>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/pick-up-list/search-form/search-form.component.html